import React, { useState } from 'react';
import { IDashboardTemplateFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { CollapseSection, DashboardTemplate } from '../components';
import MyDashboardsAvatar from './MyDashboardsAvatar';
import { DashboardNavSectionType } from '../../types';

interface IProps {
  templates: IDashboardTemplateFieldsFragment[];
}

const MyDashboards = ({ templates }: IProps) => {
  const [mouseOverId, setMouseOverId] = useState<string | null>(null);
  const [openedMenuId, setOpenedMenuId] = useState<string | null>(null);

  return (
    <CollapseSection
      variant={DashboardNavSectionType.My}
      headerComponent={<MyDashboardsAvatar />}
      title={'My Dashboards'}
    >
      {templates.map((template) => (
        <DashboardTemplate
          key={`${DashboardNavSectionType.My}-${template.baseId}`}
          template={template}
          variant={DashboardNavSectionType.My}
          mouseOverId={mouseOverId}
          setMouseOverId={setMouseOverId}
          openedMenuId={openedMenuId}
          setOpenedMenuId={setOpenedMenuId}
        />
      ))}
    </CollapseSection>
  );
};

export default MyDashboards;
